import PropTypes from 'prop-types';
import React from 'react';
import Slider from 'react-slick';
import { isMobileOnly } from 'react-device-detect';

import ChevronLeft from '../../../assets/icons/chevron-left.svg';
import ChevronRight from '../../../assets/icons/chevron-right.svg';

import './Carousel.scss';

const ButtonNext = ({ marginedButtons, onClick }) => (
  <button type="button" className={`action-button next ${marginedButtons ? 'large-margin' : ''}`} onClick={onClick}>
    <img src={ChevronRight} className="icon" alt="next" />
  </button>
);
ButtonNext.propTypes = {
  onClick: PropTypes.func,
  marginedButtons: PropTypes.bool.isRequired,
};
ButtonNext.defaultProps = {
  onClick: () => {},
};

const ButtonBack = ({ marginedButtons, onClick }) => (
  <button type="button" className={`action-button previous ${marginedButtons ? 'large-margin' : ''}`} onClick={onClick}>
    <img src={ChevronLeft} className="icon" alt="previous" />
  </button>
);
ButtonBack.propTypes = {
  onClick: PropTypes.func,
  marginedButtons: PropTypes.bool.isRequired,
};
ButtonBack.defaultProps = {
  onClick: () => {},
};

const Carousel = ({
  children, draggable, marginedButtons, visibleSlides, shadowed, autoPlay, onSlideChange,
}) => {
  const [mobile, setMobile] = React.useState(false);

  React.useEffect(() => {
    setMobile(isMobileOnly);
  }, []);

  const onSlideFocus = (currentSlideIndex) => {
    if (onSlideChange) {
      onSlideChange(currentSlideIndex);
    }
  };

  /* const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: mobile ? 1 : visibleSlides,
    slidesToScroll: 1,
    centerMode: true,
    className: 'center',
    centerPadding: '0px',
    nextArrow: <ButtonNext />,
    prevArrow: <ButtonBack />,
    beforeChange: (oldIndex, newIndex) => onSlideFocus(newIndex),
    autoplay: autoPlay,
    draggable,
    swipeToSlide: draggable,
    touchMove: true,
  }; */

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: mobile ? 1 : visibleSlides,
    slidesToScroll: 1,
    nextArrow: <ButtonNext marginedButtons={marginedButtons} />,
    prevArrow: <ButtonBack marginedButtons={marginedButtons} />,
    beforeChange: (oldIndex, newIndex) => onSlideFocus(newIndex),
    autoplay: autoPlay,
    draggable,
    swipeToSlide: draggable,
    touchMove: true,
  };

  return (
    <Slider {...settings} className={`carousel ${shadowed ? 'shadowed' : ''}`}>
      {React.Children.map(children, (child, index) => (
        <div
          key={index}
          className={`slide ${mobile && 'no-horizontal-padding'}`}
        >
          {child}
        </div>
      ))}
    </Slider>
  );
};

Carousel.propTypes = {
  children: PropTypes.any.isRequired,
  autoPlay: PropTypes.bool,
  draggable: PropTypes.bool,
  marginedButtons: PropTypes.bool,
  shadowed: PropTypes.bool,
  onSlideChange: PropTypes.func,
  visibleSlides: PropTypes.number,
};

Carousel.defaultProps = {
  autoPlay: false,
  draggable: true,
  marginedButtons: false,
  shadowed: false,
  onSlideChange: () => {},
  visibleSlides: 3,
};

export default Carousel;
